import React from 'react';
import ProdamusLogo from './components/ProdamusLogo/ProdamusLogo';
import XLLogo from './components/XLLogo/XLLogo';

type LogoProps = {
    theme?: 'light' | 'dark';
    width?: string | number;
    height?: string | number;
    productVersion?: 'xl' | 'pro';
};

const getProductVersion = (): string => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    if (hostname.includes('xlcrm.ai') || hostname.includes('xlclient.ai')) {
        return 'xl';
    }
    return 'pro';
};

const Logo: React.FC<LogoProps> = ({ theme, width, height, productVersion }) => {
    const domain = productVersion ?? getProductVersion();

    if (domain === 'xl') {
        return <XLLogo theme={theme} width={width} height={height} />;
    }

    return <ProdamusLogo theme={theme} width={width} height={height} />;
};
Logo.defaultProps = {
    theme: 'light',
    height: 100
};
export default Logo;
